import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Button, Fade, useTheme } from '@mui/material';
import { MouseEvent, useRef, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { CardEventLayout } from './layouts/card-event-layout';
import { FreeLayout } from './layouts/free-layout';
import { NavItemProps } from 'types/header';

export const NavItem = ({ item, navContext }: NavItemProps) => {
  const { title, path, hasDropdown, dropdownItems, disabled, cardEvent } = item;
  const { openItemId, openDropdown, closeDropdown } = navContext;
  const isOpen = openItemId === title;
  const dropdownRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const theme = useTheme();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen &&
        dropdownRef.current &&
        buttonRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        closeDropdown();
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.addEventListener('mousedown', handleClickOutside as any);
    return () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      document.removeEventListener('mousedown', handleClickOutside as any);
    };
  }, [isOpen, closeDropdown]);

  const handleClick = () => {
    if (hasDropdown) {
      if (isOpen) {
        closeDropdown();
      } else {
        openDropdown(title);
      }
    }
  };

  return (
    <Box component="li" sx={{ display: 'inline-block' }}>
      {hasDropdown ? (
        <Button
          onClick={handleClick}
          ref={buttonRef}
          disabled={disabled}
          disableFocusRipple
          disableRipple
          disableTouchRipple
          sx={{
            padding: isOpen ? '6px 10px' : '6px 10px',
            // fontFamily: 'Instrument Sans',
            // fontWeight: 600,
            // fontSize: '12px',
            lineHeight: '20px',
            letterSpacing: '0%',
            textAlign: 'center',
            verticalAlign: 'middle',
            textTransform: 'none',
            transition: 'all 0.2s ease-in-out',
            color: 'text.primary',
            '&:hover': {
              // backgroundColor: 'transparent',
              backgroundColor: theme.palette.primary.lighter,
            },
            // ...(!isOpen && {
            // }),
            ...(isOpen && {
              backgroundColor: theme.palette.primary.lighter,
              // backgroundColor: 'rgba(255, 255, 255, 0.8) !important',
              boxShadow: '0px 8px 16px 0px rgba(4, 10, 23, 0.06) !important',
            }),
          }}
          endIcon={isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        >
          {title}
        </Button>
      ) : (
        <Button
          component={RouterLink}
          to={path}
          disabled={disabled}
          sx={{
            // fontFamily: 'Instrument Sans',
            // fontWeight: 600,
            // fontSize: '12px',
            lineHeight: '20px',
            letterSpacing: '0%',
            textAlign: 'center',
            verticalAlign: 'middle',
            textTransform: 'none',
            transition: 'all 0.2s ease-in-out',
            color: 'text.primary',
            '&:hover': {
              backgroundColor: 'transparent',
              // color: 'text.primary',
              color: theme.palette.primary.main,
            },
            px: 0,
            minWidth: 'auto',
          }}
        >
          {title}
        </Button>
      )}

      {hasDropdown && dropdownItems && isOpen && (
        <Fade in={isOpen} timeout={200}>
          <Box
            ref={dropdownRef}
            sx={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              marginLeft: '-4px',
              transform: 'translate(-50%, 0%)',
              mt: '24px',
              height: 392,
              width: 920,
              backgroundColor: 'background.paper',
              borderRadius: 2,
              padding: '40px 24px',
              boxShadow: '0px 20px 32px 0px rgba(0, 0, 0, 0.1)',
              zIndex: 1300,
              overflowX: 'hidden',
              transition: 'box-shadow 0.2s ease-in-out',
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                left: 20,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            }}
          >
            {cardEvent ? (
              <CardEventLayout
                dropdownItems={dropdownItems}
                cardEvent={cardEvent}
                closeDropdown={closeDropdown}
              />
            ) : (
              <FreeLayout
                dropdownItems={dropdownItems}
                closeDropdown={closeDropdown}
              />
            )}
          </Box>
        </Fade>
      )}
    </Box>
  );
};
